import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';

import {Observable} from 'rxjs';

import {environment} from '@env/environment';

export interface Periodic {
  id: number;
  issn: string;
  name: string;
}

@Injectable({providedIn: 'root'})
export class PeriodicService {

  constructor(private http: HttpClient) {
  }

  getPeriodics(param: string = ''): Observable<Periodic[]> {
    return this.http.get<Periodic[]>(`${environment.base_url}/periodics?param=${param}`);
  }

  getPeriodicsByProject(projectId: number): Observable<any> {
    return this.http.get(`${environment.base_url}/periodics/projects/${projectId}`);
  }

  attachToProject(projectId: number, selectedPeriodicsIds: number[]): Observable<any> {
    return this.http.post(`${environment.base_url}/periodics/projects`, {
      project_id: projectId,
      periodics_ids: selectedPeriodicsIds
    });
  }
}
